import React from "react";
import { Route, Redirect } from "react-router-dom";
import ApiLayout from '../containers/layout/apiLayout';

export default ({ component: C, props: cProps, ...rest }) =>
  <Route
    {...rest}
    render={props =>
      (cProps.isAuthenticated && cProps.isAdmin && rest.validate)
    ?  <ApiLayout {...props} {...cProps} component={(props) => <C {...cProps} {...props} />} />
        : <Redirect
            to={`/`}
          />}
  />;

  //</MainLayout><C {...props} {...cProps} />